
export default class DownloadOverlay {

    // constructor
    constructor(selector) {
        this.init(selector);
    }


    // init
    init(selector) {

        let vm = this;

        // plugin selector
        this.$plugin = $(selector);

        // if plugin does not exist, cancel
        if (this.$plugin.length === 0) {
            return false;
        }

        // load event handlers
        this.eventHandlers();
    }


    /**
     * events to handle
     */
    eventHandlers() {
        let _this = this;

        // click on item
        $(document).on('click', '[data-tncp-download-overlay-triggerer]', function(event) {
            event.preventDefault();
            _this.openOverlay();
            _this.downloadAction($(this).data('tncp-download-overlay-source'));
        });

        $(document).on('click', '[data-tncp-download-overlay-closer]', function(event) {
            event.preventDefault();
            _this.closeOverlay();
        });
    }


    downloadAction(source) {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = source;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(source);
        document.body.removeChild(a);
    }

    openOverlay() {
        $('[data-tncp-download-overlay]').css('display', 'block');
    }

    closeOverlay() {
        $('[data-tncp-download-overlay]').css('display', 'none');
    }
}

